import { ScaleElement } from '@scale/base-element';
import { Events } from '@scale/events';

class ProductQuantitySelector extends ScaleElement {
  setup() {
    const input = this.ref('quantity-input');
    if (!input) return;

    const minus = this.ref('minus');
    const plus = this.ref('plus');

    if (minus) this.on('click', () => this.#step(-1), { target: minus });
    if (plus) this.on('click', () => this.#step(1), { target: plus });
    this.on('change', () => this.#clamp(), { target: input });

    this.onDocument(Events.VARIANT_SELECTED, (e) => {
      if (!e.variant) return;
      const rule = e.variant.quantity_rule || {};
      input.min = rule.min || 1;
      input.max = rule.max || 9999;
      input.step = rule.increment || 1;
      input.value = rule.min || 1;
    });
  }

  #step(direction) {
    const input = this.ref('quantity-input');
    if (!input) return;
    const step = Number(input.step) || 1;
    const min = Number(input.min) || 1;
    const max = Number(input.max) || 9999;
    const next = Number(input.value) + (step * direction);
    input.value = Math.min(max, Math.max(min, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  #clamp() {
    const input = this.ref('quantity-input');
    if (!input) return;
    const min = Number(input.min) || 1;
    const max = Number(input.max) || 9999;
    const val = Number(input.value);
    if (val < min) input.value = min;
    if (val > max) input.value = max;
  }
}

if (!customElements.get('product-quantity-selector')) {
  customElements.define('product-quantity-selector', ProductQuantitySelector);
}
